import { get, postFormData, postJson } from '@/utils/request'

// 获取头部菜单
export const getHeaderMenu = (data) => get('/api/web/main/header', data)

// 新增 banner
export const getBanner = (data) => get('/api/web/main/imageList', data)

//获取服务
export const getFwkhList = (data) => get('/api/web/main/fwkhList', data)

//中新新闻
export const getNewsList = (data) => get('/api/web/main/articleList', data)

//获取职业人员信息
export const getZyryList = (data) => get('/api/web/main/zyryList', data)

//获取底部信息
export const getBaseInfo = (data) => get('/api/web/main/baseInfo', data)

//菜单内容
export const clickColumn = (data) => get('/api/web/click/clickColumn', data)

//获取详情
export const getDetail = (data) => get('/api/web/click/articleDetail', data)